import { cn } from "@/lib/utils";
import type { RolloutPolicy } from "@tilt/admin-sdk";

/** V0089 - broadcast = Live (green), controlled = Pilot (amber). */
export function RolloutPolicyBadge(props: { policy: RolloutPolicy }): JSX.Element {
  const isLive = props.policy === "broadcast";
  return (
    <span
      className={cn(
        "rounded-sm px-1.5 py-0.5 text-[10px] font-medium uppercase",
        isLive
          ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300"
          : "bg-amber-500/15 text-amber-700 dark:text-amber-300",
      )}
    >
      {isLive ? "Live" : "Pilot"}
    </span>
  );
}
